import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import inboxService from "@/services/inbox";

export const useInboxStore = defineStore("inbox", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchUnreadMessagesCounter(id) {
    loading.value = true;
    try {
      const res = await inboxService.getUnreadMessagesCounter(id);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchMessagesDetails(payload) {
    loading.value = true;
    try {
      const res = await inboxService.getMessagesDetails(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchUnreadMessagesCounter,
    fetchMessagesDetails,
  };
});
